import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { paymentStatus } from "@/lib/pay";

const PaymentReturn = ({ cancel = false }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [msg, setMsg] = useState(cancel ? "Paiement annulé." : "Confirmation du paiement…");
    const tries = useRef(0);

    useEffect(() => {
        if (cancel) { const t = setTimeout(() => navigate("/apercu"), 1500); return () => clearTimeout(t); }
        const sid = new URLSearchParams(location.search).get("session_id");
        if (!sid) { navigate("/"); return; }
        const poll = async () => {
            tries.current += 1;
            try {
                const d = await paymentStatus(sid);
                if (d.payment_status === "paid") { navigate("/accueil"); return; }
            } catch (e) {}
            if (tries.current > 15) { setMsg("Toujours en cours… tu peux revenir plus tard."); return; }
            setTimeout(poll, 2000);
        };
        poll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="fixed inset-0 bg-black flex flex-col items-center justify-center gap-4" data-testid="payment-return">
            {!cancel && <div className="w-10 h-10 rounded-full border-2 border-ink-700 border-t-revred animate-spin" />}
            <p className="text-white text-base">{msg}</p>
        </div>
    );
};

export default PaymentReturn;
